export default __webpack_public_path__ + "static/winter38-52a81dd31be554def4b3e727f91fe856.webp";